const USER_TYPE = {
  wholeseller: 'wholeseller',
  retailer: 'retailer',
  customer: 'customer',
  admin: 'admin',
  guest: 'guest',
}

export default USER_TYPE
